import {useRef} from "react";
import {useStore} from "react-redux";

import {isSmartAdServerStageEnv} from "../../app/read_rp_environment_variables";
import {initSmartAdServer} from "../../smart_ad_server/init_smart_ad_server";
import {IRootState, RpStore} from "../../store/store";
import {SmartAdSASTypes} from "../helpers/smart_add_sas_types";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";

export function useSmartAdServerOnOfferList() {
    const firstLoad = useRef(true);
    const store = useStore<IRootState>();

    return (singleRegion?: ISelectedRegion) => {
        if (singleRegion) {
            const citySlug = singleRegion?.stats?.region_type_city?.slug;
            const voivodeshipSlug = singleRegion?.stats?.region_type_voivodeship?.slug || "mazowieckie";
            const adTarget = `region=${voivodeshipSlug};region_id=${singleRegion?.id};region_parent_city=${citySlug}`; // NOTE: parent should always exist

            return configureSmartAdServerForOfferListView(adTarget, firstLoad.current, store);
        }

        firstLoad.current = false;
    };
}

async function configureSmartAdServerForOfferListView(target: string, firstLoad: boolean, store: RpStore) {
    initSmartAdServer(
        {
            siteId: isSmartAdServerStageEnv ? 387263 : 394399,
            pageId: isSmartAdServerStageEnv ? 1336206 : 1349933,
            formats: [
                {id: SmartAdSASTypes.MONO_NATIVE_ADD},
                {id: SmartAdSASTypes.OFFER_OF_THE_MONTH},
                {id: SmartAdSASTypes.IMAGE},
                {id: SmartAdSASTypes.SURPRISE},
                // {id: SmartAdSASTypes.HERO},
                {id: SmartAdSASTypes.TDA}
            ],
            target
        },
        !firstLoad,
        store
    );
}
import {useRef} from "react";
import {useStore} from "react-redux";

import {isSmartAdServerStageEnv} from "../../app/read_rp_environment_variables";
import {initSmartAdServer} from "../../smart_ad_server/init_smart_ad_server";
import {IRootState, RpStore} from "../../store/store";
import {SmartAdSASTypes} from "../helpers/smart_add_sas_types";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";

export function useSmartAdServerOnOfferList() {
    const firstLoad = useRef(true);
    const store = useStore<IRootState>();

    return (singleRegion?: ISelectedRegion) => {
        if (singleRegion) {
            const citySlug = singleRegion?.stats?.region_type_city?.slug;
            const voivodeshipSlug = singleRegion?.stats?.region_type_voivodeship?.slug || "mazowieckie";
            const adTarget = `region=${voivodeshipSlug};region_id=${singleRegion?.id};region_parent_city=${citySlug}`; // NOTE: parent should always exist

            return configureSmartAdServerForOfferListView(adTarget, firstLoad.current, store);
        }

        firstLoad.current = false;
    };
}

async function configureSmartAdServerForOfferListView(target: string, firstLoad: boolean, store: RpStore) {
    initSmartAdServer(
        {
            siteId: isSmartAdServerStageEnv ? 387263 : 394399,
            pageId: isSmartAdServerStageEnv ? 1336206 : 1349933,
            formats: [
                {id: SmartAdSASTypes.MONO_NATIVE_ADD},
                {id: SmartAdSASTypes.OFFER_OF_THE_MONTH},
                {id: SmartAdSASTypes.IMAGE},
                {id: SmartAdSASTypes.SURPRISE},
                // {id: SmartAdSASTypes.HERO},
                {id: SmartAdSASTypes.TDA}
            ],
            target
        },
        !firstLoad,
        store
    );
}
